import { getTsPatientPortalClient } from '@montugroup/circuit-shared/api/patient-portal.client';
import type { apiPatientPortalContract } from '@montugroup/pms-api-contracts';
import type { z } from 'zod';

type TreatmentLetterResponse = z.infer<
  (typeof apiPatientPortalContract.createConfirmationOfTreatmentLetter.responses)[201]
>;

export type TreatmentLetterData = TreatmentLetterResponse['data'];

export const useCreateConfirmationOfTreatmentLetter = () => {
  const client = getTsPatientPortalClient();

  const {
    mutateAsync: baseMutateAsync,
    data,
    mutate,
    ...mutation
  } = client.createConfirmationOfTreatmentLetter.useMutation({
    retry: false,
  });

  const mutateAsync = async (clientCode: string, prescriptionCode: string): Promise<TreatmentLetterData> => {
    const res = await baseMutateAsync({
      params: { prescriptionCode },
      body: {
        data: {
          patientCode: clientCode,
        },
      },
    });

    if (res.status !== 201 && res.status !== 200) {
      throw res;
    }
    return res.body.data;
  };

  return {
    ...mutation,
    mutateAsync,
    refetch: mutate,
    preSignedUrl: data?.body.data.preSignedUrl,
    documentPath: data?.body.data.documentPath,
  };
};
